<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">{{'Gasto' | translate}} Recurrente</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isValidating">

      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Listado de Gastos Recurrentes
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- FILTROS DE BUSQUEDA -->
        <mat-expansion-panel *ngIf="!isValidating">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="searchForm">

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!checkVerSoloRecurrentes()">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Fecha de Gasto Desde</mat-label>
                  <input matInput [matDatepicker]="fechaGastoDesdePicker" formControlName="FechaGastoDesde"  (click)="fechaGastoDesdePicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoDesde')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaGastoDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha de Gasto Hasta</mat-label>
                  <input matInput [matDatepicker]="fechaGastoHastaPicker" formControlName="FechaGastoHasta"  (click)="fechaGastoHastaPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoHasta')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaGastoHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                  <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="ComunidadId">
                    <mat-option>Todas</mat-option>
                    <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isConsorcioSearching">Consorcio</mat-label>
                  <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                  <mat-select formControlName="ConsorcioId">
                    <mat-option>Todos</mat-option>
                    <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Detalle</mat-label>
                  <input matInput formControlName="Detalle" (keyup.enter)="onSearch()">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Código de UF</mat-label>
                  <input matInput formControlName="UnidadFuncionalCodigo" (keyup.enter)="onSearch()">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoGastoSearching">Tipo de Gasto</mat-label>
                  <mat-label *ngIf="isTipoGastoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoGastoId">
                    <mat-option>Todos</mat-option>
                    <mat-option *ngFor="let s of tipoGastoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isServicioGastoSearching">Servicio</mat-label>
                  <mat-label *ngIf="isServicioGastoSearching">Cargando...</mat-label>
                  <mat-select formControlName="ServicioGastoId">
                    <mat-option>Todos</mat-option>
                    <mat-option *ngFor="let s of servicioGastoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Clase de Gasto</mat-label>
                  <mat-select formControlName="ClaseGasto">
                    <mat-option>Ver de Todas</mat-option>
                    <mat-option *ngFor="let s of claseGastoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput [matAutocomplete]="proveedor"
                    formControlName="Proveedor">
                  <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                    class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                </mat-form-field>
                <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                  <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                    {{s.RazonSocial }}
                  </mat-option>
                </mat-autocomplete>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-checkbox formControlName="VerSoloRecurrentes" color="primary">Ver solo gastos recurrentes</mat-checkbox>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="!checkVerSoloRecurrentes()">
              <button mat-raised-button (click)="searchGastosRecurrentes()" [disabled]="isProcessing()" color="primary" class="zb-button">{{isGastoDeudaSearching ? 'Buscando...' : 'Buscar'}}</button>
            </div>

          </form>

        </mat-expansion-panel>

        <br/>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px;">
              <mat-label><b>TOTAL A PAGAR:</b></mat-label>
              <br/>
              <ng-container *ngIf="!isSearching">
                <mat-label *ngFor="let item of totalesSeleccionados" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

        </div>

        <!--GRILLA DE DEUDAS-->
        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">

            <mat-expansion-panel [expanded]="true" hideToggle="false">

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isGastoDeudaSearching">
                <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isGastoDeudaSearching" style="margin-top: 15px;">

                <ejs-grid #deudasGrid [dataSource]='deudasPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                  [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column field='FechaGasto' headerText='Fecha Gasto' width="11%"></e-column>
                    <e-column field='FechaVencimiento' headerText='Vencimiento' width="11%"></e-column>
                    <e-column headerText='Referencia' width="14%"></e-column>
                    <e-column field='TipoGasto' headerText='Tipo' width="15%"></e-column>
                    <e-column field='ServicioGasto' headerText='Tipo' width="15%"></e-column>
                    <e-column field='Detalle' headerText='Detalle' width="20%"></e-column>
                    <e-column field='Moneda' headerText='Moneda' width="10%"></e-column>
                    <e-column field='ImporteBase' headerText='Monto Base' width="14%" format="N2"></e-column>
                    <e-column field='AlicuotaIvaId' headerText='IVA' width="10%"></e-column>
                    <e-column headerText='' width="7%"></e-column>
                  </e-columns>
                  <ng-template #rowTemplate let-data>
                    <tr class="e-row">
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input class="text-style" matInput [matDatepicker]="fechaGastoPicker" [(ngModel)]="data.FechaGasto" name="FechaGasto"  (click)="fechaGastoPicker.open()"
                          (dateChange)="onDeudaGridFieldChange(data.Id, $event)" style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                        <mat-datepicker #fechaGastoPicker></mat-datepicker>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoPicker" [(ngModel)]="data.FechaVencimiento" name="FechaVencimiento"  (click)="fechaVencimientoPicker.open()"
                          (dateChange)="onDeudaGridFieldChange(data.Id, $event)" style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                        <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        {{data.Comunidad}}{{data.TipoReferencia == 'UF' ? ' - ' + data.UfCodigo : ''}}
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        {{data.TipoGasto}}
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        {{data.ServicioGasto}}
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input matInput [(ngModel)]="data.Detalle" name="Detalle" (change)="onDeudaGridFieldChange(data.Id, $event)"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                        <mat-select class="text-style" [(ngModel)]="data.MonedaId" name="MonedaId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isMonedaSearching"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                          <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                        </mat-select>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 5px 10px;">
                        <input matInput type="number" [(ngModel)]="data.ImporteBase" name="ImporteBase" (change)="onDeudaGridFieldChange(data.Id, $event)"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                        <mat-select [(ngModel)]="data.AlicuotaIvaId" name="AlicuotaIvaId" (selectionChange)="onDeudaGridFieldChange(data.Id, $event)" *ngIf="!isAlicuotaIvaSearching"
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                          <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <a style="cursor: pointer; margin-right: 5px" (click)="openAdjuntos(data)" *ngIf="data.Adjuntos != null && data.Adjuntos.length > 0" [title]="data.Adjuntos.length + ' archivos adjuntos'">
                          <i class="fa fa-file fa-1x"></i>
                        </a>
                        <a style="cursor: pointer; margin-right: 5px" (click)="adjuntoInput.click()" [disabled]="isFileAttaching" title="Adjuntar archivos al gasto">
                          <i class="fa fa-upload fa-1x"></i>
                          <input hidden (change)="onFileAttach(data.Id, $event)" #adjuntoInput type="file" multiple>
                        </a>
                        <!-- <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label> -->
                        <a style="cursor: pointer; margin-right: 5px" (click)="onRemove(data.Id)" title="Eliminar del listado">
                          <i class="fa fa-times fa-1x"></i>
                        </a>
                      </td>
                    </tr>
                  </ng-template>
                </ejs-grid>

              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isGastoDeudaSearching" style="margin-top: 15px; text-align: right;">
                <mat-checkbox [(ngModel)]="solicitarConfirmacion">Solicitar confirmación para cada acción</mat-checkbox>
              </div>

            </mat-expansion-panel>

          </div>

        </div>

      </mat-expansion-panel>

    </div>

  </mat-card-content>

  <mat-card-actions>
    <div class="flex-actions">
      <button mat-raised-button (click)="onGuardar()" [disabled]="isProcessing()" color="primary" class="zb-button" *ngIf="deudasPendientesList != null && deudasPendientesList.length > 0">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn">Cancelar</button>
    </div>
  </mat-card-actions>

</mat-card>
